import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetTokensPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/inputs/get-tokens-paginated.form-default-values';
import { GetTokensPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/inputs/get-tokens-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterTokenListContextProvider,
  useTokenListContext,
} from '../token.context';
import { TokenListFilterFormController } from './token-list-filter-form/token-list-filter-form.controller';

interface TokenListFilterControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const TokenListFilterController = ({
  onCancel,
  onSuccess,
}: TokenListFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useTokenListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetTokensPaginatedModel> = (errors) => {
    Logger.error(errors);
    toast.error(t('$.token-list-filter.error', { error: t('global.unknown') }));
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<GetTokensPaginatedModel> = (
    fieldValues,
  ) => {
    setGetPaginatedQueryParameters((current) => {
      return {
        ...current,
        // ?? undefined: the "valid" control uses `null` as its "All"
        // sentinel (see token-is-valid-filter.controller.tsx) to work
        // around a react-hook-form Controller quirk — normalize back to
        // `undefined` here for the actual query parameters.
        valid: fieldValues.valid ?? undefined,
        type: fieldValues.type,
      };
    });
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetTokensPaginatedDefaultValues(getPaginatedQueryParameters);

  return (
    <FilterTokenListContextProvider data={data}>
      <TokenListFilterFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterTokenListContextProvider>
  );
};
